export default __webpack_public_path__ + "static/screenshot-target-scores--mobile-e63c26fee5cb6da453576b0b6bd69a39.webp";